import { render, staticRenderFns } from "./UrlShortener.vue?vue&type=template&id=10099b48&"
import script from "./UrlShortener.vue?vue&type=script&lang=js&"
export * from "./UrlShortener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports